import { defaultSelectedRingtoneDevice } from '../constants/common';
import {
  SET_CALL_DIRECTION,
  SET_PHONE_FIELD_VALUE,
  SET_SUBSCRIBER,
  SET_IS_CONTROL_PANEL_VISIBLE,
  SET_NUM_PAD_VISIBLE,
  SET_PHONE_FIELD_POS,
  SET_SILENT_MODE,
  SET_RINGTONE_PLAY_ERROR,
  SET_RINGTONE_DEVICES_DATA,
  SET_SELECTED_RINGTONE_DEVICE,
  SET_USER_MEDIA_ERROR,
  SET_SERVICE_COMPANY,
  SET_COMPANY_VISIBLE,
} from './actionTypes';

const initialState = {
  callDirection: null,
  phoneFieldValue: '',
  phoneFieldPos: 0,
  subscriber: null,
  isControlPanelVisible: false,
  numPadVisible: false,
  silentMode: process.env.REACT_APP_SILENT_MODE === 'true',
  ringtonePlayError: null,
  ringtoneDevicesData: {
    deviceList: [],
    error: undefined,
  },
  selectedRingtoneDevice: defaultSelectedRingtoneDevice,
  userMediaError: null,
  serviceCompany: null,
  companyVisible: null,
};

const phoneReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CALL_DIRECTION:
      return {
        ...state,
        callDirection: payload,
      };
    case SET_COMPANY_VISIBLE:
      return {
        ...state,
        companyVisible: payload,
      };
    case SET_SERVICE_COMPANY:
      return {
        ...state,
        serviceCompany: payload,
      };
    case SET_PHONE_FIELD_VALUE:
      return {
        ...state,
        phoneFieldValue: payload,
      };
    case SET_SUBSCRIBER:
      return {
        ...state,
        subscriber: payload,
      };
    case SET_IS_CONTROL_PANEL_VISIBLE:
      return {
        ...state,
        isControlPanelVisible: payload,
      };
    case SET_NUM_PAD_VISIBLE:
      return {
        ...state,
        numPadVisible: payload,
      };
    case SET_PHONE_FIELD_POS:
      return {
        ...state,
        phoneFieldPos: payload,
      };
    case SET_SILENT_MODE:
      return {
        ...state,
        silentMode: payload,
      };
    case SET_RINGTONE_PLAY_ERROR:
      return {
        ...state,
        ringtonePlayError: payload,
      };
    case SET_RINGTONE_DEVICES_DATA:
      return {
        ...state,
        ringtoneDevicesData: payload,
      };
    case SET_SELECTED_RINGTONE_DEVICE:
      return {
        ...state,
        selectedRingtoneDevice: payload,
      };
    case SET_USER_MEDIA_ERROR:
      return {
        ...state,
        userMediaError: payload,
      };
    default:
      return state;
  }
};

export default phoneReducer;
